import { authorizationMiddleware } from '../authorization/authorization.middleware'
import { workspaceMiddleware } from '@/store/workspace/workspace.middleware'
import { projectMiddleware } from '@/store/project/project.middleware'

export const combineMiddleware = [authorizationMiddleware, workspaceMiddleware, projectMiddleware]
